import { z } from 'zod';
import { ExternalContactSchema } from '../../entities/external-contact/external-contact.schema';
import { IncludeDeletedRequestSchema } from '../../shared/include-deleted.schema';
/**
 * List External Contacts Request Schema
 * GET /api/v2/external-contacts
 */ export const ListExternalContactsRequestSchema = IncludeDeletedRequestSchema;
/**
 * List External Contacts Response Schema
 * GET /api/v2/external-contacts
 */ export const ListExternalContactsResponseSchema = z.object({
    data: z.array(ExternalContactSchema)
});

//# sourceMappingURL=list-external-contacts.schema.js.map